/* ============================================================
   NOMADI FINANCING CTA — SITE-WIDE JAVASCRIPT v4
   Logo-based version: All company logos clickable → LendPro
   Injects scoped CSS to override theme's global img rules
   ============================================================ */

(function() {
  'use strict';

  var LENDPRO_URL = 'https://ingress.mylendpro.com/page/shortAuth/a97a5b63-84e7-4fd9-b01b-94ce3d75b90e';

  // Get logo URLs from Shopify CDN (injected by theme)
  var LOGO_URLS = window.NOMADI_FINANCE_LOGOS || {};

  // ============================================================
  // 0. INJECT SCOPED CSS TO OVERRIDE THEME IMAGE RULES
  // ============================================================
  function injectScopedCSS() {
    var style = document.createElement('style');
    style.id = 'nomadi-finance-logo-overrides';
    style.textContent = [
      '#nomadi-floating-finance img { max-width: 55px !important; max-height: 16px !important; width: auto !important; height: auto !important; object-fit: contain !important; display: block !important; }',
      '#nomadi-financing-bar img { max-width: 80px !important; max-height: 26px !important; width: auto !important; height: auto !important; object-fit: contain !important; display: block !important; }',
      '#nomadi-financing-bar .nfb-logo-sm { max-width: 55px !important; max-height: 16px !important; }',
      '.nomadi-card-finance img { max-width: 40px !important; max-height: 12px !important; width: auto !important; height: auto !important; object-fit: contain !important; display: block !important; }',
      '#nomadi-floating-finance a { display: inline-flex !important; align-items: center !important; flex-shrink: 0 !important; }',
      '#nomadi-financing-bar a { display: inline-flex !important; align-items: center !important; flex-shrink: 0 !important; }',
      '.nomadi-card-finance a { display: inline-flex !important; align-items: center !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ============================================================
  // 1. FLOATING FINANCING BANNER (with logos)
  // ============================================================
  function createFloatingBanner() {
    // Don't show on cart page (already has financing)
    if (document.body.classList.contains('template-cart')) return;
    // Don't show if already dismissed this session
    if (sessionStorage.getItem('nomadi_finance_dismissed')) return;

    // Delay appearance for 3 seconds after page load
    setTimeout(function() {
      var banner = document.createElement('div');
      banner.className = 'nomadi-floating-finance';
      banner.id = 'nomadi-floating-finance';
      banner.innerHTML = [
        '<button class="nomadi-floating-finance__close" aria-label="Close">&times;</button>',
        '<div class="nomadi-floating-finance__content">',
        '  <div class="nomadi-floating-finance__icon">',
        '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">',
        '      <rect x="2" y="5" width="20" height="14" rx="2"/>',
        '      <path d="M2 10h20"/>',
        '    </svg>',
        '  </div>',
        '  <div class="nomadi-floating-finance__text">',
        '    <span class="nomadi-floating-finance__headline">',
        '      Finance Your Furniture <span>All Credit Types</span>',
        '    </span>',
        '    <span class="nomadi-floating-finance__subtext">',
        '      Pre-qualify in seconds — no credit hit.',
        '    </span>',
        '    <div style="display:flex;align-items:center;gap:6px;margin-top:6px;flex-wrap:wrap;">',
        '      <a href="' + LENDPRO_URL + '" target="_blank"><img src="' + (LOGO_URLS.affirm || '') + '" alt="Affirm" style="background:#fff;border-radius:3px;padding:2px 4px;"></a>',
        '      <a href="' + LENDPRO_URL + '" target="_blank"><img src="' + (LOGO_URLS.lendpro || '') + '" alt="LendPro" style="background:#fff;border-radius:3px;padding:2px 4px;"></a>',
        '      <a href="' + LENDPRO_URL + '" target="_blank"><img src="' + (LOGO_URLS.acima || '') + '" alt="Acima" style="background:#fff;border-radius:3px;padding:2px 4px;"></a>',
        '      <a href="' + LENDPRO_URL + '" target="_blank"><img src="' + (LOGO_URLS.snap || '') + '" alt="Snap" style="background:#fff;border-radius:3px;padding:2px 4px;"></a>',
        '      <a href="' + LENDPRO_URL + '" target="_blank"><img src="' + (LOGO_URLS.klarna || '') + '" alt="Klarna" style="background:#fff;border-radius:3px;padding:2px 4px;"></a>',
        '    </div>',
        '    <a href="' + LENDPRO_URL + '" target="_blank" class="nomadi-floating-finance__cta">Pre-Qualify Now</a>',
        '  </div>',
        '</div>'
      ].join('');

      document.body.appendChild(banner);

      // Close button
      banner.querySelector('.nomadi-floating-finance__close').addEventListener('click', function() {
        banner.classList.add('nomadi-floating-finance--hidden');
        sessionStorage.setItem('nomadi_finance_dismissed', '1');
        setTimeout(function() { banner.remove(); }, 400);
      });

      // Auto-hide after 15 seconds
      setTimeout(function() {
        if (banner.parentNode && !banner.classList.contains('nomadi-floating-finance--hidden')) {
          banner.classList.add('nomadi-floating-finance--hidden');
          setTimeout(function() { banner.remove(); }, 400);
        }
      }, 15000);
    }, 3000);
  }

  // ============================================================
  // 2. COLLECTION CARD FINANCING BADGES (with logos)
  // ============================================================
  function injectCollectionFinancing() {
    // Only run on collection and search pages
    var isCollection = document.body.classList.contains('template-collection') || 
                       document.body.classList.contains('template-search');
    if (!isCollection) return;

    var priceElements = document.querySelectorAll('.product-item__price-list');
    
    priceElements.forEach(function(priceEl) {
      // Don't double-inject
      if (priceEl.parentNode.querySelector('.nomadi-card-finance')) return;

      // Get the price from the element
      var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
      var prices = priceText.match(/[\d,]+\.?\d*/g);
      if (!prices || prices.length === 0) return;

      // Use the first (sale) price
      var price = parseFloat(prices[0].replace(',', ''));
      if (isNaN(price) || price < 50) return;

      // Calculate monthly payment (12 months)
      var monthly = Math.round(price / 12);

      // Create the financing badge with mini logos
      var badge = document.createElement('div');
      badge.className = 'nomadi-card-finance';
      badge.innerHTML = '<a href="' + LENDPRO_URL + '" target="_blank" style="display:flex;align-items:center;gap:6px;padding:5px 10px;background:linear-gradient(135deg,#f8f4e8,#fff8e1);border:1px solid #e8dcc8;border-radius:6px;text-decoration:none;">' +
        '<span style="font-size:11px;color:#5a4a2a;">From <strong style="color:#2a1f0a;">$' + monthly + '/mo</strong></span>' +
        '<span style="display:flex;align-items:center;gap:4px;margin-left:auto;">' +
        '<img src="' + (LOGO_URLS.affirm || '') + '" alt="Affirm">' +
        '<img src="' + (LOGO_URLS.klarna || '') + '" alt="Klarna">' +
        '</span>' +
        '</a>';

      // Insert after the price list
      priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);
    });
  }

  // ============================================================
  // 3. INITIALIZE
  // ============================================================
  function init() {
    injectScopedCSS();
    createFloatingBanner();
    injectCollectionFinancing();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after Shopify section rendering (for AJAX-loaded content)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(injectCollectionFinancing, 500);
  });
})();
